var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChotbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path975",
    d: "M0-682.665H24v24H0Z",
    transform: "translate(6445 1837.665)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1.333
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chot_bot_2",
    "data-name": "Chot bot 2",
    transform: "translate(-6445 -1155)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8788",
    "data-name": "Group 8788",
    transform: "translate(6448.156 1156.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8790",
    "data-name": "Group 8790",
    transform: "translate(0.645 0.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11295",
    "data-name": "Path 11295",
    d: "M31.4,131.252a3.785,3.785,0,0,0-3.785-3.785H18.785A3.785,3.785,0,0,0,15,131.252v3.154a3.785,3.785,0,0,0,3.785,3.785h8.831a3.785,3.785,0,0,0,3.785-3.785Z",
    transform: "translate(-15 -123.052)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11296",
    "data-name": "Path 11296",
    d: "M135.035,404.385a3.785,3.785,0,0,0-3.785-3.785h0a3.784,3.784,0,0,0-3.784,3.784h7.569Z",
    transform: "translate(-123.051 -385.461)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4932",
    "data-name": "Rectangle 4932",
    width: 11.354,
    height: 5.677,
    rx: 2.838,
    transform: "translate(2.523 6.939)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11297",
    "data-name": "Path 11297",
    d: "M140.817,253.967l-1.142.946-1.143-.946",
    transform: "translate(-133.682 -244.586)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11298",
    "data-name": "Path 11298",
    d: "M252.323,253.967l-1.142.946L250,253.967",
    transform: "translate(-240.772 -244.586)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_553",
    "data-name": "Ellipse 553",
    cx: 1.262,
    cy: 1.262,
    r: 1.262,
    transform: "translate(6.939)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1172",
    "data-name": "Line 1172",
    y2: 1.892,
    transform: "translate(8.2 2.523)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChotbot);
export default __webpack_public_path__ + "static/media/Chotbot.24399bed9258ee8c2b0a9c6913a41a56.svg";
export { ForwardRef as ReactComponent };